import React from 'react';
import googlePayIcon from '../../assets/images/icons/googlePayIcon.png';

const GPayPaymentTitle = () => {
  return (
    <img
      alt="gpay"
      src={googlePayIcon}
      height="50"
      width="50"
      style={{ border: '1px solid #1890ff', borderRadius: '100%' }}
    />
  );
};

export default GPayPaymentTitle;
